var Toast = {}
var showToast = false // 存储toast显示状态
var toastVM = null // 存储toast vm

Toast.install = function (Vue, options = {width: '', complete: function() {}}) {
  Vue.prototype.$toast = function (tips, config) {
    options.width = config && config.width ? config.width : ''
    options.complete = config && config.complete ? config.complete : function() {}
    // 兼容 $toast({ message })（如 copy 插件）；空值转空串，避免 tips.length 抛错
    if (tips && typeof tips === 'object' && tips.message != null) {
      tips = tips.message
    }
    tips = tips == null ? '' : String(tips)
    if (showToast) return
    if (!toastVM) {
      var ToastTpl = Vue.extend({
        data: function () {
          return {
            show: showToast,
            tip: tips
          }
        },
        method() {
        },
        template: `<div v-show="show" class="m-toast" style="width: ${options.width}">{{tip}}</div>`
      })
      toastVM = new ToastTpl()
      var tpl = toastVM.$mount().$el
      document.body.appendChild(tpl)
    }
    toastVM.tip = tips
    toastVM.show = showToast = true

    let wordDelay = 150
    let delay = tips.length * wordDelay < 2000 ? 2000 : 4000

    setTimeout(function () {
      toastVM.show = showToast = false
      options.complete()
    }, delay)
  }
}
module.exports = Toast
